

import { makeStyles } from 'tss-react/mui';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { Button, ContentTemplate } from 'web-library';
import { REQUEST_TYPES } from 'web-library/models/Request';
import TransactionAuditLogUpdatedDetails from 'web-library/components/TransactionAuditLogUpdatedDetails';
import { useGetDataArchivalDetail } from '../../../../api-refactored/data-archival/useGetDataArchivalDetail';
import TransactionLogModal from '../../../../components/TransactionLogModal';
import DataArchivalDetailComponent from './components/DataArchivalDetailComponent';

const useStyles = makeStyles()((theme) =>
({
  backToListingButton: {
    marginBottom: theme.spacing(7),
    height: 'fit-content',
  },
}));

const ViewDataArchival = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const { uuid } = useParams<{ uuid: string }>();

  // state
  const [openTransactionLogModal, setOpenTransactionLogModal] = useState(false);

  // hook
  const { data: archivalDetail } = useGetDataArchivalDetail({ uuid });

  // callback
  const handleBack = useCallback(() => {
    history.goBack();
  }, [history]);

  return (
    <>
      {archivalDetail && <DataArchivalDetailComponent archivalDetail={archivalDetail} />}

      <ContentTemplate continuous>
        <TransactionAuditLogUpdatedDetails
          updatedAt={archivalDetail?.lastUpdatedAt as string}
          updatedBy={archivalDetail?.lastUpdatedBy as string}
          handleOpenLogModal={() => setOpenTransactionLogModal(true)}
          label={t('admin->>UserGroups.ViewTransactionLog')}
        />

        <Button className={classes.backToListingButton} onClick={handleBack} variant="outlined">
          {t('admin->>DataArchival.BackToListing')}
        </Button>
      </ContentTemplate>

      <TransactionLogModal
        modalState={openTransactionLogModal}
        setOpenModalState={setOpenTransactionLogModal}
        requestType={REQUEST_TYPES.DATA_ARCHIVAL}
      />
    </>
  );
};

export default ViewDataArchival;
